/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import { Card, Row, Col, Form, Button, Checkbox, message, Radio, InputNumber } from "antd";
import PageToolbar from "../../components/PageToolbar";
import ReportFavoriteSave from "../../components/ReportFavoriteSave";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import GenericSelector from "../../components/GenericSelector";
import DateTimePicker from "../../components/DateTimePicker";
import moment from "moment";
import TableIDs from "../../data/TableIDs";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import GenericSelectorSuppliers from "../../components/GenericSelectorSuppliers";
import SelectorItemsMulti from "../../components/SelectorItemsMulti";


class ExcelCateringSalesHours extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            ...this.getTypeDates(2),
            _posList: "",
            _docTypeList: "",
            _centralType: '1',
            _itemList: "",
            _itemTagList: "",
            _onlyDefaultTag: "0",
            _itemSupplierList: "",
            _splitType: "1",
        };

        this.selectors = [
            { id: TableIDs.genericSelectorDocumentTypes, api: "get_document_types_list" },
        ];

        this.selectors.forEach(x => {
            if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector }
        });


    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    getTypeDates = (type) => {

        switch (type) {
            case 1: return { _fromDate: moment().day(0).format("YYYY-MM-DD"), _toDate: moment().format("YYYY-MM-DD") }
            case 2: return { _fromDate: moment().day(0).add(-7, "day").format("YYYY-MM-DD"), _toDate: moment().day(0).add(-1, "day").format("YYYY-MM-DD") }
            case 3: return { _fromDate: moment().startOf("month").format("YYYY-MM-DD"), _toDate: moment().format("YYYY-MM-DD") }
            case 4: return { _fromDate: moment().startOf("month").add(-1, "month").format("YYYY-MM-DD"), _toDate: moment().startOf("month").add(-1, "day").format("YYYY-MM-DD") }
        }
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(22789);
        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setState(this.props.ui.favoriteParams)
        }
    }

    createExcel = () => {
        const params = this.getReportParams()
        if (moment(params._fromDate).add(1, 'year').isAfter(moment(params._toDate))) {
            this.props.ActionQueue.addToQueue({ action: this.props.dataActions.generateReport, args: [this.props.user.companyCode, this.props.user.token, params] });
        } else {
            message.error(this.getText(22795));
        }
    }

    getReportParams = () => {
        let dataSend = { ...this.state }
        if (!dataSend._posList) dataSend = { ...dataSend, _posList: this.props.data.POS_STORAGE_LIST?.dataset.map(x => x.tags).flat().map(x => x.id).join(",") }
        if (!dataSend._docTypeList) dataSend = { ...dataSend, _docTypeList: '1,2,8,9,22,202,208,222'.split(",") }

        return {
            ...dataSend,
            reportName: "reports/SalesPerHours.xlsx",
            REPORT_LOCALE: this.getText(101),
        }
    }

    render() {
        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        const mobile = window.innerWidth > 600 ? false : true;


        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={this.getText(22789)} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: mobile ? '95%' : 1000 }}
                bodyStyle={{ padding: 16 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                actions={[
                    <ReportFavoriteSave
                        {...this.props}
                        params={this.getReportParams()}
                        datesToFavorites={[
                            { field: '_fromDate', label: gt(21306) },
                            { field: '_toDate', label: gt(21307) },
                        ]}
                    />,
                    <Button type="primary" onClick={this.createExcel} loading={this.props.ui.workInProgress}>{gt(21310)}</Button>,
                ]}>
                <Row>
                    <Col span={mobile ? 24 : 8}>
                        <Form.Item label={gt(21306)}>
                            <DateTimePicker
                                format="DD/MM/YYYY"
                                value={this.state._fromDate}
                                onChange={e => { this.setState({ _fromDate: e }) }}
                                maxDate={this.state._toDate}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={mobile ? 24 : 8}>
                        <Form.Item label={gt(21307)}>
                            <DateTimePicker
                                format="DD/MM/YYYY"
                                value={this.state._toDate}
                                onChange={e => { this.setState({ _toDate: e }) }}
                                minDate={this.state._fromDate}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={mobile ? 24 : 8}>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(1)) }}>{gt(22038)}</Button>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(2)) }}>{gt(22039)}</Button>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(3)) }}>{gt(22040)}</Button>
                        <Button style={{ width: "100%", marginTop: 5 }} onClick={() => { this.setState(this.getTypeDates(4)) }}>{gt(22041)}</Button>
                    </Col>
                </Row>

                <Form.Item label={gt(22791)}>
                    <GenericSelector
                        {...this.props}
                        notCodeView
                        style={{ width: 200 }}
                        dataset={[{ code: "1", name: gt(22792) }, { code: "2", name: gt(22793) }, { code: "3", name: gt(22794) }]}
                        value={this.state._centralType}
                        onChange={e => { this.setState({ _centralType: e }) }}
                    />
                </Form.Item>
                <Row>
                    <Col span={window.innerWidth > 600 ? 12 : 24} style={{ paddingLeft: 10 }}>

                        <Form.Item label={gt(22790)}>
                            <GenericSelectorPosStorages
                                {...this.props}
                                multi
                                value={this.state._posList ? this.state._posList.split(",") : []}
                                onChange={e => { this.setState({ _posList: e ? e.join(",") : "" }) }}
                            />
                        </Form.Item>

                        <Form.Item label={gt(21309)}>
                            <GenericSelector
                                {...this.props}
                                multi
                                {...this.selectors[0]}
                                filterList={'1,2,8,9,22,202,208,222'.split(",")}
                                value={this.state._docTypeList ? this.state._docTypeList.split(",") : []}
                                onChange={e => { this.setState({ _docTypeList: e ? e.join(",") : "" }) }}
                            />
                        </Form.Item>


                        <Form.Item label={gt(22796)}>
                            <GenericSelectorItemTags
                                {...this.props}
                                multi
                                value={this.state._itemTagList ? this.state._itemTagList.split(",") : []}
                                onChange={e => { this.setState({ _itemTagList: e ? e.join(",") : "" }) }}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Checkbox
                                checked={this.state._onlyDefaultTag == '1'}
                                onChange={e => { this.setState({ _onlyDefaultTag: e.target.checked ? "1" : "0" }) }}
                            >{gt(22797)}</Checkbox>
                        </Form.Item>

                    </Col>

                    <Col span={window.innerWidth > 600 ? 12 : 24} style={{ paddingRight: 10 }}>

                        <Form.Item label={gt(22798)}>
                            <SelectorItemsMulti
                                {...this.props}
                                fieldName={"_itemList"}
                                onChange={e => { this.setState({ _itemList: e ? e.join(",") : "" }) }}
                            />
                        </Form.Item>


                        <Form.Item label={gt(22799)}>
                            <GenericSelectorSuppliers
                                {...this.props}
                                multi
                                value={this.state._itemSupplierList ? this.state._itemSupplierList.split(",") : []}
                                onChange={e => { this.setState({ _itemSupplierList: e ? e.join(",") : "" }) }}
                            />
                        </Form.Item>

                        <Form.Item label={gt(22804)}>
                            <Radio.Group value={this.state._splitType} onChange={e => { this.setState({ _splitType: e.target.value }) }}>
                                <Radio value={"1"}>{gt(22802)}</Radio><br />
                                <Radio value={"2"}>{gt(22803)}</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
            </Card>


        </div>)
    }


}

export default ExcelCateringSalesHours;